import { render } from "./contactSlide.vue?vue&type=template&id=2465bb74&scoped=true"
import script from "./contactSlide.vue?vue&type=script&lang=js"
export * from "./contactSlide.vue?vue&type=script&lang=js"

import "./contactSlide.vue?vue&type=style&index=0&id=2465bb74&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2465bb74"]])

export default __exports__